import React, { useState } from "react";
import { api } from "../api";

/**
 * Owner-only "reset the instance to empty" control.
 *
 * PROTOTYPE / DEMO ONLY — this exists so a demo visitor can wipe the sample
 * data and start fresh. Do NOT ship this in a real production deployment.
 */
export default function ClearDataButton({ label = "Clear all data" }) {
  const [open, setOpen] = useState(false);
  const [word, setWord] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const clearAll = async () => {
    setBusy(true); setErr("");
    try {
      await api.post("/config/reset-data");
      window.location.reload();   // reload into the now-empty system
    } catch (e) {
      setErr(e?.response?.data?.detail || "Couldn't clear data");
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" className="btn btn-danger" onClick={() => setOpen(true)}>
        {label}
      </button>

      {open && (
        <div className="modal-backdrop" onClick={() => !busy && setOpen(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ width: 440 }}>
            <h3 style={{ color: "var(--red)" }}>Clear all school data?</h3>
            <p className="text-2" style={{ fontSize: 13, marginTop: -4 }}>
              Permanently deletes all students, teachers, parents, fees, payments,
              attendance, timetable, marks and assignments, leaving an empty system.
              Your owner &amp; staff logins, accounts, tiles and settings are kept.
              This cannot be undone.
            </p>
            {err && <div className="error-banner">{err}</div>}
            <div className="form-row">
              <label>Type <strong>CLEAR</strong> to confirm</label>
              <input className="input" value={word} autoFocus
                     onChange={(e) => setWord(e.target.value)} placeholder="CLEAR"/>
            </div>
            <div className="flex gap-8" style={{ justifyContent: "flex-end" }}>
              <button type="button" className="btn btn-secondary" disabled={busy}
                      onClick={() => { setOpen(false); setWord(""); }}>Cancel</button>
              <button type="button" className="btn btn-danger" disabled={busy || word !== "CLEAR"}
                      onClick={clearAll}>{busy ? "Clearing…" : "Delete everything"}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
